import { Context } from '@nuxt/types'
import { contextHolder } from '@ustra/nuxt/src/utils/nuxt-utils'

export class UtraService {
  /**
   * context 객체
   */
  protected context: Context = null

  private getContext() {
    if (this.context) {
      return this.context
    }

    this.context = contextHolder.get()
    return this.context
  }

  /**
   * get ustra plugin
   */
  protected get $ustra() {
    return this.getContext().$ustra
  }

  /**
   * get application property
   */
  protected get appProps() {
    return this.getContext().$ustra?.env?.appProp
  }
}
export class UstraService extends UtraService { }
